import { ApolloLink, Observable } from "@apollo/client";

const readContractPartnerId = (variables: Record<string, unknown> | undefined): string | undefined => {
  if (!variables) {
    return undefined;
  }
  if (typeof variables.contractPartnerId === "string") {
    return variables.contractPartnerId;
  }
  const rideFilter = variables.rideFilter as { contractPartnerId?: unknown } | undefined;
  if (rideFilter && typeof rideFilter.contractPartnerId === "string") {
    return rideFilter.contractPartnerId;
  }
  return undefined;
};

const contractPartnerGuardLink = new ApolloLink((operation, forward) => {
  const contractPartnerId = readContractPartnerId(operation.variables);

  if (contractPartnerId === "") {
    console.warn(`[contractPartnerGuardLink] Blocked "${operation.operationName}" — no contract partner selected.`);
    return new Observable((observer) => {
      observer.error(new Error("No contract partner selected"));
    });
  }

  return forward(operation);
});

export default contractPartnerGuardLink;
